import { ITracingSegment } from "../../infrastructure/tracing-segment.interface";
import { IPipeline } from "./pipeline.inferface";

export class TracingPipeline<InputType, OutputType> implements IPipeline<InputType, Promise<OutputType>> {

	private segment: ITracingSegment;
	private pipeline: IPipeline<InputType, OutputType>;

	constructor(pipeline: IPipeline<InputType, OutputType>, segment: ITracingSegment) {
		this.segment = segment;
		this.pipeline = pipeline;
	}

	public async run(input: InputType): Promise<OutputType> {
		let output;

		try {
			output = await this.pipeline.run(input);
		} catch (e) {
			this.segment.addError(e);
			throw e;
		} finally {
			this.segment.close();
		}

		return output;
	}
}
